module.exports = __webpack_public_path__ + "img/hmzg.c932ee4d.png";